import {
  Component, EventEmitter,
  Input, Output,
  ViewChild,
} from '@angular/core';
import { LMFieldPickerLookupComponent, LMFieldValueChangedEvent, LMLookupBasicComponent } from '@app/components';
import { LMFieldPickerSelectOptions } from "@modal/field-picker/lm-field-picker";

@Component({
  selector: 'lm-add-to-metric-compoment-dialog',
  templateUrl: './lm-add-to-metric-compute-dialog.component.html',
  styleUrls: [ './lm-add-to-metric-compute-dialog.component.scss' ],
  standalone: false,
})
export class LMAddToMetricComputeDialogComponent {

  @Input() type: LMAddToMetricComputeType | undefined;
  @Input() metricSelectUrl: string | undefined;
  @Input() dataView: LMDataView | undefined;
  @Input() measureSelectUrl: string | undefined;
  @Input() measurePickerOptions!: LMFieldPickerSelectOptions;
  @Input() disallowMeasureOverride = false;

  @Output() lookupValueChangedEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();

  metricLabel1 = Soho.Locale.translate('MetricName1');
  metricLabel2 = Soho.Locale.translate('MetricName2');

  measureLabel1 = Soho.Locale.translate('Measure1');
  measureLabel2 = Soho.Locale.translate('Measure2');

  @ViewChild('lmMetricLookupField1') lmMetricLookupField1: LMLookupBasicComponent | undefined;
  @ViewChild('lmMetricLookupField2') lmMetricLookupField2: LMLookupBasicComponent | undefined;

  @ViewChild('lmMeasureLookupField1') lmMeasureLookupField1: LMFieldPickerLookupComponent | undefined;
  @ViewChild('lmMeasureLookupField2') lmMeasureLookupField2: LMFieldPickerLookupComponent | undefined;

  // selectListUrl: string | undefined;
  sourceField: string | undefined;
  metricValue1 = '';
  metricValue2 = '';
  measureValue1 = '';
  measureValue2 = '';

  showMeasure1 = false;
  showMeasure2 = false;

  constructor() {
    // no-op
  }

  handleMetric1LookupValueChanged(event: LMFieldValueChangedEvent) {
    if (this.lmMetricLookupField1)
      this.metricValue1 = this.lmMetricLookupField1.lookupValue;
  }

  handleMetric2LookupValueChanged(event: LMFieldValueChangedEvent) {
    if (this.lmMetricLookupField2)
      this.metricValue2 = this.lmMetricLookupField2.lookupValue;
  }

  handleMeasure1LookupValueChanged(value: string) {
    if (this.lmMeasureLookupField1)
      this.measureValue1 = value; // this.lmMeasureLookupField1.fieldValue();
  }

  handleMeasure2LookupValueChanged(value: string) {
    if (this.lmMeasureLookupField2)
      this.measureValue2 = value; // this.lmMeasureLookupField2.fieldValue();
  }
}
